/*
 *   Copyright (c) 2020
 *   All rights reserved.
 */
import $ from "jquery";
import Swiper from "swiper/bundle";
import ClipboardJS from "clipboard";

/**
 * Simulate a click event.
 * @public
 * @param {Element} elem  the element to simulate a click on
 */
var simulateClick = function (elem) {
  // Create our event (with options)
  var evt = new MouseEvent("click", {
    bubbles: true,
    cancelable: true,
    view: window,
  });
  // If cancelled, don't dispatch our event
  var canceled = !elem.dispatchEvent(evt);
};

var changeSocials = function () {
  const slide = $(".swiper-slide-active").first();
  const url = slide.attr("data-url");
  const title = slide.attr("data-title");
  const image = slide.attr("data-image");

  //facebook
  $("#shareable-fb").attr(
    "href",
    `https://www.facebook.com/sharer/sharer.php?u=${url}&t=${title}`
  );
  $("#shareable-tw").attr(
    "href",
    `https://twitter.com/share?url=${url}&via=claralionelfdn&text=${title}`
  );
  // $("#shareable-ig").attr(
  //   "href",
  //  `https://www.instagram.com/?url=${url}`
  //);
  $("#shareable-ml").attr(
    "href",
    `mailto:?subject=${title}&body=URL: ${url}%0D%0AImage: ${image}`
  );
  $("#shareable-lk").attr("href", url);
  $("#shareable-lk").attr("data-clipboard-text", url);
  $("#shareable-dw").attr("href", image);
};

class SwiperImages {
  constructor() {
    this.init();
  }

  init() {
    $(".share-section .shareable-lk").attr("tabindex", "0");
    const clipboard = new ClipboardJS(".shareable-lk");
    clipboard.on("success", function (e) {
      $(".sharing-confirmation").css("visibility", "visible");
      setTimeout(() => {
        $(".sharing-confirmation").css("visibility", "hidden");
      }, 1000);
      e.clearSelection();
    });

    $("#shareable-lk").keydown(function (e) {
      if (e.keyCode === 13) {
        const copyText = $(this).attr("data-clipboard-text");
        const element = document.createElement("input"); 
        element.type = "text";
        element.value = copyText;
        document.body.append(element);
        element.select();
        document.execCommand("copy");
        document.body.removeChild(element);

        $(".sharing-confirmation").css("visibility", "visible");
        setTimeout(() => {
          $(".sharing-confirmation").css("visibility", "hidden");
        }, 1000);
      }
    });

    const swiper = new Swiper(".swiper-container", {
      effect: "coverflow",
      loop: false,
      loopFillGroupWithBlank: true,
      grabCursor: true,
      slidesPerView: "auto",
      centeredSlides: "true",
      updateOnWindowResize: "true",
      coverflowEffect: {
        rotate: 0,
        stretch: 0,
        depth: 100,
        modifier: 5,
        slideShadows: true,
      },
      pagination: {
        el: ".swiper-pagination",
        type: "fraction",
      },
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
      breakpoints: {
        // when window width is >= 370px
        320: {
          coverflowEffect: {
            rotate: 0,
            stretch: 0,
            depth: 500,
            modifier: 5,
            slideShadows: true,
          },
        },
        // when window width is >= 768px
        768: {
          coverflowEffect: {
            rotate: 0,
            stretch: 0,
            depth: 100,
            modifier: 1,
            slideShadows: true,
          },
        },
        // when window width is >= 890px
        1050: {
          coverflowEffect: {
            rotate: 0,
            stretch: 0,
            depth: 50,
            modifier: 5,
            slideShadows: true,
          },
        },
      },
      on: {
        slideChange: function (e) {
          changeSocials();
        },
        slideChangeTransitionEnd: function (e) {
          changeSocials();
        },
      },
    });

    var socialKitLink = document.querySelector(
      "#clf2020-social-kit-global-btn"
    );
    $(".clf2020-social-kit-trigger button, .clf2020-social-kit-trigger").on(
      "click",
      (evt) => {
        evt.preventDefault();
        var url = $(evt.currentTarget).attr("data-share").trim();
        var slide = $(`.swiper-slide[data-url='${url}']`).first();
        var slideCount = parseInt(
          slide.attr("aria-label").split("/")[0].trim()
        );
        swiper.slideTo(slideCount - 1);
        changeSocials();
        simulateClick(socialKitLink);
        $("#clf2020-social-kit-global-btn").click();
      }
    );
  }
}

export default SwiperImages;
